import { BenefitName } from 'gql/autogen/BenefitName';
import { BenefitType } from 'gql/autogen/BenefitType';

export const benefitNameCms: Record<BenefitName, number> = {
    [BenefitName.AIR_CONDITION]: 130779,
    [BenefitName.AIRPORT_TAX]: 130803,
    [BenefitName.ALCOHOL]: 130781,
    [BenefitName.ALL_FEES_AND_TAX]: 130799,
    [BenefitName.ALL_INGREDIENTS]: 130790,
    [BenefitName.BICYCLE]: 130798,
    [BenefitName.BREAKFAST]: 130789,
    [BenefitName.CERTIFICATE]: 130775,
    [BenefitName.COFFEE_AND_TEA]: 130784,
    [BenefitName.COOKING_UTENSILS]: 130791,
    [BenefitName.DINNER]: 130787,
    [BenefitName.FUEL_SURCHARGE]: 130806,
    [BenefitName.GRATUITIES]: 130801,
    [BenefitName.GST]: 130802,
    [BenefitName.LANDING_AND_FACILITY_FEES]: 130805,
    [BenefitName.LUNCH]: 130788,
    [BenefitName.OTHER]: 130807,
    [BenefitName.OTHER_EQUIPMENT]: 130792,
    [BenefitName.PARKING_FEES]: 130800,
    [BenefitName.PRIVATE]: 130777,
    [BenefitName.RECIPE_BOOKLET]: 130774,
    [BenefitName.REFRESHMENTS]: 130780,
    [BenefitName.SCUBA_EQUIPMENT]: 130797,
    [BenefitName.SEGWAY]: 130794,
    [BenefitName.SNACKS]: 130786,
    [BenefitName.SNORKELING_EQUIPMENT]: 130796,
    [BenefitName.SOFT_DRINK]: 130783,
    [BenefitName.TOILET]: 130778,
    [BenefitName.TRIKKE]: 130795,
    [BenefitName.UNKNOWN]: 130808,
    [BenefitName.WATER]: 130785,
    [BenefitName.WIFI]: 130776,
};

export const benefitTypeCms: Record<BenefitType, number> = {
    [BenefitType.EQUIPMENT]: 130809,
    [BenefitType.FEES_AND_TAXES]: 130813,
    [BenefitType.FOOD_AND_DRINK]: 130812,
    [BenefitType.SOUVENIRS]: 130811,
    [BenefitType.TRANSPORT_AMENITIES]: 130810,
    [BenefitType.UNKNOWN]: 130808,
    [BenefitType.OTHER]: 130807,
};
